import React, { FunctionComponent } from 'react';

export type ServerErrorProps = {
  message?: string;
};

export const ServerError: FunctionComponent<ServerErrorProps> = ({
  message = '',
}) => (
  <>
    <p className="text-lg mb-sm">Oops!</p>
    <p>
      We encountered an issue trying to perform that action, sorry! Our
      engineers have been notified, but if the problem persists please get in
      touch using the chat in the bottom-right corner
    </p>
    {message && message !== '' && (
      <p className="mt-sm">The error was: {message}</p>
    )}
  </>
);
